module.exports = __webpack_public_path__ + "img/nettanlegg.80283dae.jpg";